<script setup>
import { config } from '@/utils/config'

defineProps({
  isPortal: Boolean
})
</script>

<template>
  <a
    :href="config.store_url"
    target="_blank"
    rel="noopener noreferrer"
    class="inline-flex items-center bg-white border border-solid border-gray-400 rounded p-1"
  >
    <div class="p-1">
      <img src="@/assets/images/logo.svg" width="100px" />
    </div>
  </a>
</template>
